(function(window, angular) {
  "use strict";

  angular.module('service')
  .factory('pipeService', ['baseService', function(baseService) {
    // inherits
    var extended = angular.copy(baseService);
    // url
    extended.base_url = getFullUrl('/api/pipe');

    return extended;
  }]);
})(window, window.angular);
